var _defs, _path, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIDenteqIconsSvg01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.7 141.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #0d73b2;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 5px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.8,91.4l-4.9,4.9c-1.3,1.3-1.3,3.5,0,4.8l9.7,9.7c1.3,1.3,3.5,1.3,4.8,0l4.9-4.9,10.2,4.2v6.9c0,1.9,1.5,3.4,3.4,3.4h13.7c1.9,0,3.4-1.5,3.4-3.4v-6.9l10.2-4.2,4.9,4.9c1.3,1.3,3.5,1.3,4.8,0l9.7-9.7c1.3-1.3,1.3-3.5,0-4.8l-4.9-4.9,4.2-10.2h6.9c1.9,0,3.4-1.5,3.4-3.4v-13.7c0-1.9-1.5-3.4-3.4-3.4h-6.9l-4.2-10.2,4.9-4.9c1.3-1.3,1.3-3.5,0-4.8l-9.7-9.7c-1.3-1.3-3.5-1.3-4.8,0l-4.9,4.9-10.2-4.2v-6.9c0-1.9-1.5-3.4-3.4-3.4h-13.7c-1.9,0-3.4,1.5-3.4,3.4v6.9l-10.2,4.2-4.9-4.9c-1.3-1.3-3.5-1.3-4.8,0l-9.7,9.7c-1.3,1.3-1.3,3.5,0,4.8l4.9,4.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 21.3,
    y1: 70.7,
    x2: 85.5,
    y2: 70.7
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.2,
    y1: 88,
    x2: 85.5,
    y2: 70.7
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 68.4,
    y1: 53.6,
    x2: 85.5,
    y2: 70.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIDenteqIconsSvg01);
export default __webpack_public_path__ + "static/media/IDenteq_Icons_SVG-01.6ab306168cb7f05b510b22b52ef9f15c.svg";
export { ForwardRef as ReactComponent };